//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required as validateRequired } from 'vuelidate/lib/validators'

import formValidation from '~/mixins/formValidation'

export default {
  mixins: [formValidation],
  props: {
    id: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      listeners: {
        input: (event) => this.onInput(event.target.value),
        blur: (event) => this.onInvalid(),
        keyup: (event) => this.onInvalid(),
      },
    }
  },

  mounted() {
    this.$emit('invalid', {
      invalid: this.$v.$invalid,
      name: this.name,
    })
  },

  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
    onInvalid() {
      // reset error
      this.error = null

      // set error
      if (this.required && !this.$v.value.required) {
        this.error = this.$translation('form.required')
      } else {
        this.error = null
      }

      // set invalid
      this.invalid = this.$v.$invalid
      this.$emit('invalid', {
        invalid: this.invalid,
        name: this.name,
        error: this.error,
      })
    },
  },
  validations() {
    return {
      value: {
        required: this.required ? validateRequired : true,
      },
    }
  },
}
